import { Box, Center, Drawer, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, Flex, useDisclosure } from "@chakra-ui/react";
import CommonButton from "../../common/CommonButton";
import InvestingDrawer from "../../common/InvestingDrawer";
import DealsTable from "./DealsTable";

function DealsSection() {

  const { isOpen, onOpen, onClose } = useDisclosure();
  
  return (
    <Flex
      w="full"
      alignItems="center"
      justify="center"
      overflowX="hidden"
      fontFamily="'IBM Plex Mono', monospace"
    >
      <Center>
        <Flex
          direction="column"
          w="full"
          color="rgb(0 0 0 / 85%)"
          alignItems="center"
          maxW="55rem"
          gap={[6]}
          pt={[8, 8, 20, 16]}
          pb={[20, 20, 20, 16]}
          px={[6, 6, 8, 0]}
        >
          <Box
            fontSize={["3xl"]}
            fontWeight="semibold"
            w="full"
            mb="-2"
            fontFamily="'Poppins', sans-serif"
          >
            Deals
          </Box>
          <Box
            fontFamily="'IBM Plex Mono', monospace"
            fontSize={["sm"]}
            lineHeight="1.5715"
          >
            Investing in the liquidity pool means you automatically have
            exposure to all senior tranches of all deals. Currently the pool
            consists of <b>21 deals of 12 borrowers.</b>
          </Box>
          <Box display={["none", "none", "block", "block"]} w={["100%", "100%", "100%", "full"]} overflowX="auto">
            <DealsTable />
          </Box>
          <Flex w="full" gap={6}>
            <Box display={["none", "none", "block", "block"]}>
              <CommonButton
                name="Explore all deals"
                onClick={() => {
                  console.log("clicked");
                }}
                bg="white"
                hoverBg="rgba(245, 245, 245, 1)"
              />
            </Box>
            <Box display={["block", "block", "none", "none"]}>
              <CommonButton
                name="Explore"
                onClick={() => {
                  console.log("clicked");
                }}
                bg="white"
                hoverBg="rgba(245, 245, 245, 1)"
              />
            </Box>
            <Box>
              <CommonButton
                name="Invest"
                onClick={onOpen}
                bg="rgba(187, 247, 208, 1)"
                hoverBg="rgba(74, 222, 128, 1)"
              />
              <Drawer size="full" onClose={onClose} isOpen={isOpen}>
                <DrawerOverlay />
                <DrawerContent
                  bg="rgba(245, 245, 245, 1)"
                >
                  <DrawerHeader>
                    <InvestingDrawer onDrawerClose={onClose} />
                  </DrawerHeader>
                  <DrawerFooter></DrawerFooter>
                </DrawerContent>
              </Drawer>
            </Box>
          </Flex>
        </Flex>
      </Center>
    </Flex>
  );
}

export default DealsSection;
